import React from 'react'
import styled from 'styled-components'
import Icon from 'react-fontawesome'

import Util from 'helpers/Util'
import Color from 'helpers/Color'
import { Logo } from 'components/UI'

const Wrapper = styled.div`
  background-color: ${Color.green};
  display: flex;
  justify-content: space-around;
  align-items: center;
`
const MenuIcon = styled(Icon)`
  color: ${Color.white};
  cursor: pointer;

  ${Util.desktopOnly} {
    display: none;
  }
`

const Header = ({ onToggleClick }) => (
  <Wrapper>
    <Logo />
    <MenuIcon
      name='bars'
      size='3x'
      onClick={onToggleClick}
    />
  </Wrapper>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/App/Header.jsx